<template>
  <div v-if="idxPatient">
    <div class="container container-fluid">
      <h6 class="pull-left text-muted">
        <router-link v-if="idxPatient.idxPatientType === 1"
          :to="{ name: 'indexpatient_gen_negative', params: { id: idxPatient.indexPatientId }}">
          &#171; Tillbaka
        </router-link>
        <router-link v-if="idxPatient.idxPatientType === 2"
          :to="{ name: 'indexpatient', params: { id: idxPatient.indexPatientId }}">
          &#171; Tillbaka
        </router-link>
      </h6>
      <h1 class="pull-left text-muted">Redigera indexpatient</h1>
      <h4 class="pull-left text-muted">{{ idxPatient.firstName }} {{ idxPatient.lastName }}</h4>
      <div class="clearfix"></div>
      <!-- Uppgifter -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Uppgifter</strong></p>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="ssn">Personnummer:</label>
                <input type="number"
                  placeholder="YYYYMMDDXXXX"
                  class="form-control"
                  id="ssn"
                  v-model="idxPatient.ssn"
                  minlength="12">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="lastname">Efternamn:</label>
                <input type="text" class="form-control" id="lastname" v-model="idxPatient.lastName">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="firstname">Tilltalsnamn:</label>
                <input type="text" class="form-control" id="firstname" v-model="idxPatient.firstName">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- Omfattning screening -->
      <div class="card journal-card" v-if="clinicians.length > 0">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Ansvarig vårdgivare</strong></p>
          <div class="row">
            <div class="col-sm-4">
            <select class="form-control pull-right" v-model="idxPatient.clinicianId">
              <option disabled selected>Välj vårdgivare</option>
              <option v-for="c in clinicians" v-text="c.clinicianName" :value="c.clinicianId" :key="c.clinicianId">
              </option>
            </select>
            </div>
            <div class="col-sm-4">
              <p class="pull-left">Vårdgivare för denna indexpatient är förvald men du kan tilldela en ny från listan.</p>
            </div>
            <div class="col-sm-4"></div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- Kontaktuppgifter -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Kontaktuppgifter</strong></p>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="email">E-post:</label>
                <input type="email" class="form-control" id="email" v-model="idxPatient.emailAddress">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="pull-left" for="phonenumber">Telefonnummer:</label>
                <input type="number" class="form-control" id="phonenumber" v-model="idxPatient.phoneNumber">
              </div>
            </div>
            <div class="col-sm-4"></div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- FH-diagnos -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>FH-diagnos</strong></p>
          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <label class="pull-left" for="mutationlong">Långt mutationsnamn + kort mutationsnamn:</label>
                <select
                  class="form-control"
                  v-model="tempMutation"
                  @change="emptyMutations()"
                  :disabled="((this.idxPatient.mutationLong && this.idxPatient.mutationLong.length !== 0) ||
                    (this.idxPatient.mutation && this.idxPatient.mutation.length !== 0)) ||
                    idxPatient.idxPatientType === 1">
                  <option :value="'Ej applicerbart'" v-if="idxPatient.idxPatientType === 1">Ej applicerbart</option>
                  <option :value="null">Välj mutation</option>
                  <option
                    v-for="(mutationshort, mutationlong) in data.clinicMisc.mutationlist"
                    :value="mutationlong + ' | ' + mutationshort"
                    :key="mutationlong">
                    {{ mutationlong }} {{ mutationshort }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label class="pull-left" for="mutation">Långt mutationsnamn:</label>
                <div class="input-group">
                  <input type="text"
                    :disabled="tempMutation !== null"
                    class="form-control"
                    placeholder="Skriv långt mutationsnamn"
                    v-model="idxPatient.mutationLong">
                  <span class="input-group-append" title="Rensa fält">
                    <button type="button" :disabled="tempMutation !== null"
                      @click="idxPatient.mutationLong = null" class="input-clear"></button>
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label class="pull-left" for="mutation">Kort mutationsnamn:</label>
                <div class="input-group">
                  <input type="text"
                    :disabled="tempMutation !== null"
                    class="form-control"
                    placeholder="Skriv kort mutationsnamn"
                    v-model="idxPatient.mutation">
                  <span class="input-group-append" title="Rensa fält">
                    <button type="button" :disabled="tempMutation !== null"
                      @click="idxPatient.mutation = null" class="input-clear"></button>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm">
              <div class="form-group">
                <label class="text-left" for="diagnosisfacility">Diagnosställe (rullista):</label>
                <select class="form-control" v-model="tempFacility"
                :disabled="idxPatient.diagnosisLocation !== null && idxPatient.diagnosisLocation.length !== 0">
                  <option :value="null">Välj diagnosställe</option>
                  <option
                    v-for="(region, facility) in data.clinicMisc.mutationFacilityList"
                    :value="facility"
                    :key="facility">
                    {{ facility }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label class="text-left" for="diagnosislocation">Diagnosställe:</label>
                <div class="input-group">
                  <input type="text"
                    class="form-control"
                    id="diagnosislocation"
                    placeholder="Skriv diagnosställe"
                    v-model="idxPatient.diagnosisLocation"
                    :disabled="tempFacility !== null">
                  <span class="input-group-append" title="Rensa fält">
                    <button type="button" :disabled="tempFacility !== null"
                      @click="idxPatient.diagnosisLocation = null" class="input-clear"></button>
                  </span>
                </div>
              </div>
              <div class="form-group pull-left">
                <label class="text-center" for="diagnosisdate">Diagnosdatum:</label><br />
                <date-pick
                  v-model="diagnosisDate"
                  id="diagnosisdate" :displayFormat="'YYYY-MM-DD'"
                  @input="idxPatient.diagnosisDate = diagnosisDate"
                  :inputAttributes="{name: diagnosisDate, id: diagnosisDate, class: ['form-control'],
                    readonly: true, placeholder: 'Välj diagnosdatum'}">
                </date-pick>
              </div>
            </div>
          </div>
          <div class="row" v-if="idxPatient.idxPatientType === 1">
            <div class="col-sm-4">
              <p class="text-dark pull-left">Ange det högsta journalförda LDL värde</p>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">LDL</span>
                </div>
                <input type="text" class="form-control" v-model="idxPatient.ldl" v-on:keypress="isCharAllowed($event)">
              </div>
            </div>
            <div class="col-sm-2">
              <p class="text-dark pull-left"><strong>Enhet</strong></p>
              <div class="input-group mb-3">
                <input type="text" class="form-control" v-model="idxPatient.ldlUnit">
              </div>
            </div>
            <div class="col-sm-5">
              <p class="text-dark pull-left"><strong>Referensintervall</strong></p>
              <div class="input-group mb-3">
                  <select class="form-control" v-model="idxPatient.ldlReferenceInterval">
                    <option :value="''">Välj intervall för LDL</option>
                    <option
                      v-for="(ldl, i) in intervalLists.clinicMisc.ldlRefList"
                      v-html="ldl"
                      :key="i"
                      :title="ldl">
                    </option>
                  </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm"></div>
          <div class="col-sm"></div>
          <div class="col-sm"></div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- DLCN -->
      <div class="card journal-card" v-if="idxPatient.idxPatientType === 1">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Dutch Lipid Score</strong></p>
          <div class="row">
            <div class="col-sm-4">
              <label>Dutch Lipid Clinic Network Criteria Score som FH diagnos grundar sig på</label>
              <select class="form-control m-w-220" v-model="idxPatient.highestDLCN">
                <option :value="null">Välj från 0-18</option>
                <option v-for="d in dlcnIntervals" :value="d" :key="d">{{ d }}</option>
              </select>
            </div>
            <div class="col-sm"></div>
            <div class="col-sm"></div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- Omfattning screening -->
      <div class="card journal-card">
        <div class="card-body">
          <p class="text-dark pull-left"><strong>Omfattning screening</strong></p>
          <div class="row">
            <div class="col-sm-4">
              <div class="checkbox">
                <label><input type="radio" v-model="idxPatient.screening" :value="1"> &nbsp; Mammas sida</label>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="checkbox">
                <label><input type="radio" v-model="idxPatient.screening" :value="2"> &nbsp; Pappas sida</label>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="checkbox">
                <label><input type="radio" v-model="idxPatient.screening" :value="3"> &nbsp; Okänt</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="btn-group">
        <button class="btn btn-lg btn-primary" @click="editIdxPatient()" :disabled="!isFieldsValid">Spara ändringar</button>
        <button class="btn btn-lg btn-danger" @click="confirmLeave()">Avbryt</button>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { request } from '../plugins/datocms'
import { luhnSsn } from '../plugins/luhnssn'
import { inRange } from '../plugins/numberhelper'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'

export default {
  name: 'editidxpatient',
  components: {
    DatePick
  },
  props: ['id'],
  data () {
    return {
      data: null,
      idxPatient: null,
      clinicianId: parseInt(localStorage.getItem('clinicianId')) || 0,
      diagnosisDate: null,
      tempMutation: null,
      tempFacility: null,
      clinicians: []
    }
  },
  methods: {
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    stringToInt (str) {
      if (str) {
        return parseInt(str)
      }
    },
    boolToText (bool) {
      if (bool) {
        return 'Ja ⚠️'
      } else {
        return 'Nej'
      }
    },
    idxPatSsn (ssn) {
      if (ssn) {
        const output = ssn.substring(0, 4) + '-' +
                      ssn.substring(4, 6) + '-' +
                      ssn.substring(6, 8) + '-' +
                      ssn.substring(8, 12)
        return output
      }
      return '-'
    },
    isCharAllowed (e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^([0-9,-><]+)$/.test(char)) {
        return true
      } else {
        e.preventDefault()
      }
    },
    showInvMethod (method) {
      if (method === 'sms') {
        return 'SMS'
      }
      if (method === 'email') {
        return 'E-post'
      }
    },
    confirmLeave () {
      const r = confirm('Är du säker? Du kan ha osparade ändringar.')
      if (r) {
        this.$router.go(-1)
      }
    },
    prePopulateLDLReferenceInterval (age, gender) {
      if (inRange(age, 0, 1)) {
        this.idxPatient.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[0]
      } else if (inRange(age, 1, 14)) {
        this.idxPatient.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
      } else if (inRange(age, 14, 17) && gender === 'Kvinna') {
        this.idxPatient.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
      } else if (inRange(age, 14, 17) && gender === 'Man') {
        this.idxPatient.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[1]
      } else if (inRange(age, 18, 30) && gender === 'Kvinna') {
        this.idxPatient.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[2]
      } else if (inRange(age, 18, 30) && gender === 'Man') {
        this.idxPatient.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[2]
      } else if (inRange(age, 31, 50) && gender === 'Kvinna') {
        this.idxPatient.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[3]
      } else if (inRange(age, 31, 50) && gender === 'Man') {
        this.idxPatient.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[3]
      } else if (inRange(age, 51, 120) && gender === 'Kvinna') {
        this.idxPatient.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[4]
      } else if (inRange(age, 51, 120) && gender === 'Man') {
        this.idxPatient.ldlReferenceInterval = this.intervalLists.clinicMisc.ldlRefList[4]
      }
    },
    getIdxPatientById () {
      let loader = this.$loading.show()
      const url = config.indexPatientUri + '/byId?indexPatientId=' + this.$props.id
      axios._get(url).then(response => {
        this.idxPatient = response.data.indexPatient
        this.idxPatient.idxPatientType = parseInt(localStorage.getItem('patientType'))
        this.idxPatient.indexPatientType = this.idxPatient.idxPatientType
        loader.hide()
        // Handle gene negative values for LDL
        if (this.idxPatient.idxPatientType === 1 && this.idxPatient.highestLDL) {
          const parsedLDL = JSON.parse(this.idxPatient.highestLDL)
          this.idxPatient.ldl = parsedLDL.ldl
          this.idxPatient.ldlUnit = parsedLDL.ldlUnit
          this.idxPatient.ldlReferenceInterval = parsedLDL.ldlReferenceInterval
        } else {
          this.idxPatient.ldl = ''
          this.idxPatient.ldlUnit = 'mmol/L'
          this.idxPatient.ldlReferenceInterval = ''
        }
        if (this.idxPatient && this.idxPatient.diagnosisDate !== null) {
          this.diagnosisDate = this.idxPatient.diagnosisDate.substring(0, 10)
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get indexpatients: ' + error)
          loader.hide()
        }
      })
    },
    getCliniciansByIdxId () {
      const url = config.indexPatientUri + config.cliniciansUri + '?indexPatientId=' + this.$props.id
      axios._get(url).then(response => {
        this.clinicians = response.data.clinicians
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get clinicians by index id: ' + error)
        }
      })
    },
    handleIdxPatientBeforePut () {
      if (this.idxPatient.ldl.length > 0 && this.idxPatient.ldlReferenceInterval.length > 0) {
        this.idxPatient.highestLDL = JSON.stringify({
          ldl: this.idxPatient.ldl,
          ldlUnit: this.idxPatient.ldlUnit,
          ldlReferenceInterval: this.idxPatient.ldlReferenceInterval
        })
      }
      delete this.idxPatient.ldl
      delete this.idxPatient.ldlUnit
      delete this.idxPatient.ldlReferenceInterval
      if (this.tempMutation) {
        this.idxPatient.mutation = this.tempMutation.split(' | ')[1]
        this.idxPatient.mutationLong = this.tempMutation.split(' | ')[0]
      }
      if (this.tempFacility) {
        this.idxPatient.diagnosisLocation = this.tempFacility
      }
    },
    editIdxPatient () {
      const r = confirm('Är du säker på att du vill uppdatera denna indexpatient?')
      if (r) {
        let loader = this.$loading.show()
        this.handleIdxPatientBeforePut()
        axios.putIndexPatient(config.indexPatientUri, this.idxPatient).then((response) => {
          if (response) {
            setTimeout(() => {
              loader.hide()
              switch (this.idxPatient.idxPatientType) {
                case 1: // gene negative
                  window.location.href = window.location.origin.concat('/indexpatient_gen_negative/' + this.$props.id)
                  break
                case 2: // gene positive
                  window.location.href = window.location.origin.concat('/indexpatient/' + this.$props.id)
                  break
                case 3: // cardio
                  /*
                    no indexpatient view available
                    if cardio becomes indexpatient they are converted to either gene negative / positive module
                  */
                  window.location.href = window.location.origin.concat('/patientscardio')
                  break
                default: // fallback route
                  window.location.href = window.location.origin.concat('/indexpatients')
                  break
              }
            }, 1000)
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      }
    },
    emptyMutations () {
      this.idxPatient.mutation = null
      this.idxPatient.mutationLong = null
    }
  },
  computed: {
    isFieldsValid () {
      if (this.validSsn && (this.idxPatient.firstName && this.idxPatient.firstName.length !== 0) &&
      (this.idxPatient.lastName && this.idxPatient.lastName.length !== 0) &&
      (this.idxPatient.emailAddress !== null || this.idxPatient.phoneNumber !== null) &&
      ((this.idxPatient.mutation !== null && this.idxPatient.mutation.length !== 0 &&
      this.idxPatient.mutationLong !== null && this.idxPatient.mutationLong.length !== 0) || this.tempMutation) &&
      ((this.idxPatient.diagnosisLocation !== null && this.idxPatient.diagnosisLocation.length !== 0) || this.tempFacility) &&
      this.idxPatient.screening !== null && this.idxPatient.clinicianName.length !== 0 && this.idxPatient.clinicianId !== null) {
        return true
      }
    },
    validSsn () {
      if (this.idxPatient) {
        const ssnValid = luhnSsn(this.idxPatient.ssn)
        return ssnValid
      }
    },
    dlcnIntervals () {
      return Array.from(Array(19).keys())
    },
    getAge () {
      if (this.validSsn) {
        const today = new Date()
        const birthDate = new Date(this.idxPatient.ssn.substring(0, 4) +
          '/' + this.idxPatient.ssn.substring(4, 6) + '/' + this.idxPatient.ssn.substring(6, 8))
        let age = today.getFullYear() - birthDate.getFullYear()
        const m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        return age
      }
    },
    getGender () {
      if (this.validSsn) {
        const n = parseInt(this.idxPatient.ssn.charAt(10))
        if (n % 2 === 0) { // Even Number
          return 'Kvinna'
        }
        return 'Man'
      }
    }
  },
  beforeMount () {
    this.getIdxPatientById()
    this.getCliniciansByIdxId()
  },
  watch: {
    getAge (age) {
      if (age) {
        this.prePopulateLDLReferenceInterval(age, this.getGender)
      } else {
        this.idxPatient.ldlReferenceInterval = ''
      }
    },
    diagnosisDate (dd) {
      if (!dd || dd.length === 0) {
        this.diagnosisDate = null
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          misc {
            facilitylist
          }
          clinicMisc {
            mutationlist
            mutationFacilityList
          }
        }
      `
    })
    this.intervalLists = await request({
      query: `
        {
          clinicMisc {
            ldlRefList
          }
        }
      `
    })
  },
  beforeRouteLeave (to, from, next) {
    if (to.path.includes('/patients/') || to.path.includes('/indexpatient/') || to.path.includes('/indexpatient_gen_negative/')) {
      next()
    } else {
      const parts = to.path.split('/')
      const uri = '/' + parts[parts.length - 1]
      window.location.href = window.location.origin + uri
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
button:disabled {
  opacity: 0.3;
}
select:disabled, input[type=text]:disabled {
  opacity: 0.5;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
button:disabled {
  opacity: 0.3;
}
input[type=checkbox] {
    transform: scale(1.5);
}
.text-left {
  float: left;
}
.pull-left {
  text-align: left;
}
.pull-right {
  text-align: right;
}
.form-group-select {
  position: absolute;
  bottom: 0;
}
.journal-card:hover {
  background: #f8e9b8;
  border: 1px solid #efe4c2;
  color: #000;
  opacity: 1.0;
}
.journal-card {
  background: #fff8e2;
  border: 1px solid #F7ECC9;
  color: #38362E;
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/EditIdxPatient.vue